import LoopFront from "loop-front";

const CustomActivities = {
    TOGGLE_PUBLISH: 'publish'
}

export class ChapterModel extends LoopFront<{}, {}, typeof CustomActivities> {
    constructor() {
        super('chapters', {}, {}, CustomActivities);
    }
}

export const OChapter = new ChapterModel();